import { Col } from "@commonlibs";
import clsx from "clsx";
import { DrawerDivider } from "../MainDrawer.styles";
import { DrawerHeader } from "./MainDrawerHeader.styles";
import SearchInput from "../../AppBar/SearchInput/SearchInput";

export interface MainDrawerHeaderProps {
    className?: string;
    style?: React.CSSProperties;
    onMenuClick?: () => unknown;
}

function MainDrawerHeader({ className, onMenuClick, ...rest }: MainDrawerHeaderProps) {
    return (
        <Col className={clsx("main-drawer-header", className)} {...rest}>
            <DrawerHeader
                onLeftClick={onMenuClick}
                left="close"
                onRightClick={onMenuClick}
                right="support"
                center={<SearchInput data-testid="header-search-input" />}
            />
            <DrawerDivider />
        </Col>
    );
}

export default MainDrawerHeader;
